/* Stylesheets */
import "./scss/vendors/bootstrap.scss"; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
import "./scss/vendors/swiper.scss"; // ref: https://swiperjs.com/get-started#installation
import "./scss/vendors/hamburgers.scss"; // ref: https://jonsuh.com/hamburgers/#sass
import "./scss/vendors/energy-saver.scss";
//import "aos/src/sass/aos.scss";
import "./scss/fonts.scss";
import "./scss/forms.scss";
import "./scss/style.scss";

/* Scripts */
const imagesLoaded = require('imagesloaded');

import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { faFreeB } from '@fortawesome/free-brands-svg-icons';
// import { faFreeS } from '@fortawesome/free-solid-svg-icons';
// import { faFreeR } from '@fortawesome/free-regular-svg-icons';
// import { faProS } from '@fortawesome/pro-solid-svg-icons';
// import { faProR } from '@fortawesome/pro-regular-svg-icons';
// import { faProL } from '@fortawesome/pro-light-svg-icons';
// import { faProT } from '@fortawesome/pro-thin-svg-icons';
// import { faProD } from '@fortawesome/pro-duotone-svg-icons';
// import { faDuotoneR } from '@fortawesome/duotone-regular-svg-icons';
// import { faDuotoneL } from '@fortawesome/duotone-light-svg-icons';
// import { faDuotoneT } from '@fortawesome/duotone-thin-svg-icons';
// import { faSharpS } from '@fortawesome/sharp-solid-svg-icons';
// import { faSharpR } from '@fortawesome/sharp-regular-svg-icons';
// import { faSharpL } from '@fortawesome/sharp-light-svg-icons';
// import { faSharpT } from '@fortawesome/sharp-thin-svg-icons';
// import { faSharpD } from '@fortawesome/sharp-duotone-solid-svg-icons';
// import { faSharpDR } from '@fortawesome/sharp-duotone-regular-svg-icons';
// import { faSharpDL } from '@fortawesome/sharp-duotone-light-svg-icons';
// import { faSharpDT } from '@fortawesome/sharp-duotone-thin-svg-icons';
// import { faFree } from '@fortawesome/fontawesome-free';
// import { faPro } from '@fortawesome/fontawesome-pro';
// library.add(faFreeB, faFreeS, faFreeR, faProS, faProR, faProL, faProT, faProD);
// library.add(faDuotoneR, faDuotoneL, faDuotoneT);
// library.add(faSharpS, faSharpR, faSharpL, faSharpT, faSharpD, faSharpDR, faSharpDL, faSharpDT);
// library.add(faFree, faPro);
import { faEye, faEyeSlash, faAngleDown, faEnvelopeCircleCheck } from '@fortawesome/pro-light-svg-icons';
library.add(faEye, faEyeSlash, faAngleDown, faEnvelopeCircleCheck);
dom.i2svg();

//*****************************************************************
//****************** function from functions.js *******************
//*****************************************************************

// custom function (essential)
import { showLoading, hideLoading, initMenuFocusTrap, initFormValidation, setFocusOnElement, showHidePassword, scrollToAnchor, scrollToFirstErr, urlHasHash, initCleave, initCookieScriptAccessibility } from './functions.js';

// custom function (additional)
/*import { initEnergySaver, showSpinner, hideSpinner, initAOS, initSwiper, showCustomModal, showVideoModalYT } from './functions.js';*/
import { initEnergySaver, initSwiper, showCustomModal, showVideoModalYT } from './functions.js';

/* Export functions (essential) */
window.showLoading = showLoading;
window.hideLoading = hideLoading;
window.initMenuFocusTrap = initMenuFocusTrap;
window.initFormValidation = initFormValidation;
window.setFocusOnElement = setFocusOnElement;
window.showHidePassword = showHidePassword;
window.scrollToAnchor = scrollToAnchor;
window.scrollToFirstErr = scrollToFirstErr;
window.urlHasHash = urlHasHash;
window.initCleave = initCleave;
window.initCookieScriptAccessibility = initCookieScriptAccessibility;
window.showCustomModal = showCustomModal;
window.showVideoModalYT = showVideoModalYT;

// (additional)
window.initEnergySaver = initEnergySaver;
//window.showSpinner = showSpinner;
//window.hideSpinner = hideSpinner;
//window.initAOS = initAOS;
window.initSwiper = initSwiper;

//*****************************************************************
//*****************************************************************
//*****************************************************************

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
	if (document.readyState != 'loading') callback();
	else document.addEventListener('DOMContentLoaded', callback);
};
const isDebug = process.env.NODE_ENV !== 'production';
const initWebpackVersion = () => {
	isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

window.addEventListener('hashchange', () => {
	urlHasHash();
});

// TODO: gestione resize
window.addEventListener('resize', () => {

});

// TODO: gestione scroll
window.addEventListener('scroll', () => {

});

/* Ready callback function */
ready(() => {

	// (essential)
	initWebpackVersion();
	initMenuFocusTrap();
	initFormValidation();
	showHidePassword();
	urlHasHash();
	initCleave();
	initCookieScriptAccessibility();

	// (additional)
	initEnergySaver();
	//initAOS();
	initSwiper();

	// Attende che tutte le immagini all'interno del <body> siano completamente caricate
	imagesLoaded('body', () => {
		hideLoading();
	});

	// Gestione click sui link di navigazione con hash
	const navLinks = document.querySelectorAll('nav a');
	if (navLinks.length === 0) return;
	Array.from(navLinks).forEach((element) => {
		element.addEventListener('click', () => {
			const href = element.getAttribute('href');
			if (!href) return;

			// Estrae il valore dell'ancora dall'href (es. "#sezione1" -> "sezione1")
			const hrefvalue = href.split('#')[1];
			// Estrae l'hash corrente dall'URL (es. "#sezione1" -> "sezione1")
			const hashvalue = window.location.hash.split('#')[1];

			// Se l'hash dell'href corrisponde a quello gi� presente nell'URL, esegue lo scroll manuale
			if (hrefvalue !== undefined && hrefvalue === hashvalue) {
				scrollToAnchor(hashvalue);
			}
		});
	});

	// Gestione click sull'hamburger menu
	const hamburger = document.querySelector('.hamburger');
	if (hamburger) {
		hamburger.addEventListener('click', function (e) {
			e.preventDefault();

			this.classList.toggle('is-active');

			const itemNav = document.querySelector('.item-nav');
			if (itemNav) {
				itemNav.classList.toggle('is-active');
			}

			const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
			const isNavActive = document.body.classList.toggle('nav-is-active');

			if (isNavActive) {
				document.body.style.paddingRight = `${scrollbarWidth}px`;
			} else {
				document.body.style.paddingRight = '';
			}

			const isExpanded = this.getAttribute('aria-expanded') === 'true';
			this.setAttribute('aria-label', isExpanded ? 'Apri il menu' : 'Chiudi il menu');
		});
	}

	// Toggle aria-expanded su tutti gli elementi che lo supportano
	Array.from(document.querySelectorAll('[aria-expanded]')).forEach((element) => {
		element.addEventListener('click', () => {
			element.setAttribute(
				'aria-expanded',
				element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
			);
		});
	});
});